const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (!bytes) {
        return '0 Byte';
    }
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    return `${Math.round(bytes / 1024 ** i, 2)} ${sizes[i]}`;
};
export default bytesToSize;
